module.exports = __webpack_public_path__ + "img/mode-4.5db2c5db.png";